import { Card, CardContent, CardImage } from "../ui/card";
import { cn } from "../../lib/utils";

export const CompanionFormStepItem = ({
  value,
  label,
  image,
  isActive,
  hasSelected,
  onChange,

  className,
  imageClassName,
  ...props
}) => {
  const isInteractive = !!onChange;

  const handleClick = () => {
    onChange(value);
  };

  return (
    <Card
      className={cn(
        "transition-all duration-300",
        isInteractive &&
          hasSelected &&
          !isActive &&
          "opacity-30 hover:opacity-60",
        isInteractive && "cursor-pointer",
        className
      )}
      active={isActive}
      onClick={handleClick}
      {...props}
    >
      {!!image && (
        <CardImage
          src={image}
          alt={label}
          className={cn(
            "w-full h-auto aspect-[9/12]",
            isInteractive && "group-hover:[&>img]:scale-105",
            imageClassName
          )}
        />
      )}
      <CardContent className="capitalize">{label}</CardContent>
    </Card>
  );
};
